<template>
    <div>
        <div class="switch" :class="switchOn" v-on:click="toggle()"></div><label v-on:click="toggle()"><slot></slot></label>
    </div>
</template>

<script>
    export default {
        props: ['value'],
        name: 'ToggleSwitch',
        computed: {
            switchOn () {
                return this.value ? 'switch-on' : 'switch-off'
            }
        },
        methods: {
            toggle () {
                this.$emit('input', !this.value)
            }
        }
    }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style>

</style>



// WEBPACK FOOTER //
// ToggleSwitch.vue?f14037cc